import { render, staticRenderFns } from "./hander.vue?vue&type=template&id=6de8781d&scoped=true&"
import script from "./hander.vue?vue&type=script&lang=js&"
export * from "./hander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8781d",
  null
  
)

export default component.exports